import {Component, OnInit} from '@angular/core';
import {GenericsService} from '../../../services/generics.service';
import {TokenStorageService} from '../../../services/token-storage.service';
import {isNullOrUndefined} from 'util';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {ActivityService} from 'ng-metro4';
import {Site} from '../../../models/admin/site';

@Component({
  selector: 'app-choice-site',
  templateUrl: './choice-site.component.html',
  styleUrls: ['./choice-site.component.css']
})
export class ChoiceSiteComponent implements OnInit {
  public sites: Site[] = [];
  public currentSites: Site[] = [];
  currentSite: Site;
  returnUrl: string;
  changeDomaine: number;

  constructor(
    public genericsService: GenericsService,
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private activityService: ActivityService
  ) {
    this.currentSites = this.tokenStorageService.getSiteToManipulate() ?
      this.tokenStorageService.getSiteToManipulate() : this.tokenStorageService.getSites();
    console.log(this.currentSites);
    this.route.queryParams.subscribe(params => {
      if (!isNullOrUndefined(params.returnUrl)) {
        this.returnUrl = params.returnUrl;
      }
    });
    if (this.currentSites && this.currentSites.length === 1) {
      this.onChoice(this.currentSites[0]);
    }
  }

  ngOnInit(): void {
    this.onPostResource('/auth/sites/find-all');
  }

  /**
   * Cette methode nous permet d'envoyer toutes les methodes avec le verbe Post de ce model
   * param url
   * param dto
   * param modelName
   */
  onPostResource(url: string): void {
    this.genericsService.getResourceAuth(url).then((result: any) => {
      if (result.code === 200) {
        this.sites = result.data;
      }
    }, error => {
    });
  }

  selectSite(cs: Site): void {
    this.currentSite = cs;
  }

  onAbandonner(): void {
    this.tokenStorageService.signOut();
  }

  onChoice(cs: Site) {
    this.tokenStorageService.saveCurrentSite(cs.id);
    this.tokenStorageService.saveCodeSite(cs.code);
    this.redirectAfterLogin();
  }

  onWorkToCentral(): void {
    this.currentSites.forEach((site) => {
      if (site.type === 'CENTRAL') {
        this.tokenStorageService.saveCurrentSite(site.id);
      }
    });
    this.redirectAfterLogin();
  }

  private redirectAfterLogin(): void {
    if (isNullOrUndefined(this.returnUrl)) {
      this.router.navigate(['/home']).then(
        () => {
          window.location.reload();
        }
      );
    } else {
      this.router.navigate([this.returnUrl]).then(
        () => {
         window.location.reload();
        }
      );
    }
  }

  onCancel(): void {
    this.currentSite = undefined;
  }
}
